<template>
  <div>
    <div class="col-md-12 wrap_word">
      <div class="col-md-1 right">
        <h1 class="main">{{ getFirstAlphabet }}</h1>
      </div>
      <div class="col-md-11">
        <app-block
          v-for="word in getVocabularyByCondition($route.params.id)"
          v-bind:key="word.keyword"
          :word="word"
        ></app-block>
      </div>
    </div>
  </div>
</template>

<script>
import Block from "@/components/Block.vue";

export default {
  components: {
    appBlock: Block
  },
  computed: {
    getVocabularyByCondition() {
      if (this.$route.name == "page") {
        return this.$store.getters.getVocabularyByAlphabet;
      } else if (this.$route.name == "word") {
        return this.$store.getters.getVocabularyByWord;
      } else if (this.$route.name == "strategy") {
        return this.$store.getters.getVocabularyByStrategy;
      } else if (this.$route.name == "reform") {
        return this.$store.getters.getVocabularyByReform;
      } else if (this.$route.name == "masterplan") {
        return this.$store.getters.getVocabularyByMasterplan;
      } else {
        return [];
      }
    },
    getFirstAlphabet() {
      if (this.$route.name == "page") {
        return this.$route.params.id;
      } else if (this.$route.name == "word") {
        //return this.$route.params.id[0];
        return "";
      } else {
        return "";
      }
    }
  }
};
</script>
